import { render } from "./AboutSection.vue?vue&type=template&id=ca4d12e2&ts=true"
import script from "./AboutSection.vue?vue&type=script&lang=ts"
export * from "./AboutSection.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__